/**
 * Google Analytics (gtag.js) — inicijalizacija i SPA page view tracking.
 * Tracking ID dolazi iz REACT_APP_GA_KEY; podržava UA i GA4 formate.
 */

let initializedTrackingId = null;

/**
 * @param {string} trackingId
 */
export function initGoogleAnalytics(trackingId) {
  if (!trackingId || typeof window === 'undefined') return;
  if (initializedTrackingId === trackingId) return;

  const existingScript = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${encodeURIComponent(trackingId)}"]`,
  );
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(trackingId)}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag('js', new Date());
  window.gtag('config', trackingId);
  initializedTrackingId = trackingId;
}

/**
 * @param {string} trackingId
 * @param {string} pagePath
 */
export function trackPageView(trackingId, pagePath) {
  if (!trackingId || !pagePath || typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;

  window.gtag('config', trackingId, {
    page_path: pagePath,
  });
}
